import { render, staticRenderFns } from "./MarketplaceServicesFilteredViewAll.vue?vue&type=template&id=8824ac52&scoped=true"
import script from "./MarketplaceServicesFilteredViewAll.vue?vue&type=script&lang=js"
export * from "./MarketplaceServicesFilteredViewAll.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceServicesFilteredViewAll.vue?vue&type=style&index=0&id=8824ac52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8824ac52",
  null
  
)

export default component.exports